var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.currentDesign.font
    ? _c("aside", { staticClass: "fast-tools" }, [
        _c("div", [
          _c("div", { class: _vm.currentDesign.font.bold ? "" : "disabled" }, [
            _c(
              "button",
              {
                staticClass: "button is-small button-bold",
                class:
                  _vm.localDesign.fontBold && _vm.currentDesign.font.bold
                    ? "active"
                    : "",
                attrs: {
                  disabled: !_vm.currentDesign.font.bold,
                  role: "button",
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    ;(_vm.localDesign.fontBold = !_vm.localDesign.fontBold),
                      _vm.handleToggleChange()
                  },
                },
              },
              [
                _c("span", [_vm._v("B")]),
                _vm._v(" "),
                _vm.languageStrings.bold
                  ? _c("span", { staticClass: "tooltip" }, [
                      _vm._v(_vm._s(_vm.languageStrings.bold)),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.currentDesign.font.italic ? "" : "disabled" },
            [
              _c(
                "button",
                {
                  staticClass: "button is-small button-italic",
                  class:
                    _vm.localDesign.fontItalic && _vm.currentDesign.font.italic
                      ? "active"
                      : "",
                  attrs: {
                    disabled: !_vm.currentDesign.font.italic,
                    role: "button",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      ;(_vm.localDesign.fontItalic =
                        !_vm.localDesign.fontItalic),
                        _vm.handleToggleChange()
                    },
                  },
                },
                [
                  _c("span", [_vm._v("I")]),
                  _vm._v(" "),
                  _vm.languageStrings.italic
                    ? _c("span", { staticClass: "tooltip" }, [
                        _vm._v(_vm._s(_vm.languageStrings.italic)),
                      ])
                    : _vm._e(),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", [
            _c(
              "button",
              {
                staticClass: "button is-small button-uppercase",
                class: _vm.localDesign.uppercase ? "active" : "",
                attrs: { role: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    ;(_vm.localDesign.uppercase = !_vm.localDesign.uppercase),
                      _vm.handleToggleChange()
                  },
                },
              },
              [
                _vm.languageStrings.uppercase
                  ? _c("span", { staticClass: "tooltip" }, [
                      _vm._v(_vm._s(_vm.languageStrings.uppercase)),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.hasSavedData
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "button is-small button-delete",
                    attrs: { title: "Rensa" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.clearSavedDesign.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm.languageStrings.clear_design
                      ? _c("span", { staticClass: "tooltip" }, [
                          _vm._v(_vm._s(_vm.languageStrings.clear_design)),
                        ])
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showTextAlignment
            ? _c("div", { staticClass: "toolbar-separator" }, [_c("div")])
            : _vm._e(),
          _vm._v(" "),
          _vm.showTextAlignment
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "button is-small button-align-left",
                    class:
                      _vm.currentDesign.textalign == "left" ? "active" : "",
                    attrs: { role: "button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        ;(_vm.currentDesign.textalign = "left"),
                          _vm.handleToggleChange()
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "icon" }),
                    _vm._v(" "),
                    _vm.languageStrings.left_aligned
                      ? _c("span", { staticClass: "tooltip" }, [
                          _vm._v(_vm._s(_vm.languageStrings.left_aligned)),
                        ])
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showTextAlignment
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "button is-small button-align-center",
                    class:
                      _vm.currentDesign.textalign == "center" ? "active" : "",
                    attrs: { role: "button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        ;(_vm.currentDesign.textalign = "center"),
                          _vm.handleToggleChange()
                      },
                    },
                  },
                  [
                    _vm.languageStrings.center_aligned
                      ? _c("span", { staticClass: "tooltip" }, [
                          _vm._v(_vm._s(_vm.languageStrings.center_aligned)),
                        ])
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showTextAlignment
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "button is-small button-align-right",
                    class:
                      _vm.currentDesign.textalign == "right" ? "active" : "",
                    attrs: { role: "button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        ;(_vm.currentDesign.textalign = "right"),
                          _vm.handleToggleChange()
                      },
                    },
                  },
                  [
                    _vm.languageStrings.right_aligned
                      ? _c("span", { staticClass: "tooltip" }, [
                          _vm._v(_vm._s(_vm.languageStrings.right_aligned)),
                        ])
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showLineHeight
            ? _c("div", [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.textspacingy,
                        expression: "textspacingy",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { name: "lineheight" },
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.textspacingy = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.updateOrderObject,
                      ],
                    },
                  },
                  [
                    _c("option", { attrs: { value: "3" } }, [_vm._v("0")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "10" } }, [_vm._v("1")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "20" } }, [_vm._v("2")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "30" } }, [_vm._v("3")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "40" } }, [_vm._v("4")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "50" } }, [_vm._v("5")]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _c(
              "button",
              {
                staticClass: "button is-small gravure-icon",
                class: `${
                  _vm.visualEditorVisible ? "active-light active-arrow" : ""
                }`,
                attrs: { role: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.toggleVisualDesigner()
                  },
                },
              },
              [_c("span", { staticClass: "sr-only" }, [_vm._v("Designer")])]
            ),
          ]),
          _vm._v(" "),
          _vm.showTextAlignment && _vm.textalign == "left"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "toolbar-item toolbar-item-align-left" },
                  [
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.offset,
                            expression: "offset",
                          },
                        ],
                        attrs: { type: "number", placeholder: "0 mm" },
                        domProps: { value: _vm.offset },
                        on: {
                          change: _vm.updateOrderObject,
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.offset = $event.target.value
                          },
                        },
                      }),
                      _vm._v("\n          mm"),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showTextAlignment && _vm.textalign == "right"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "toolbar-item toolbar-item-align-right" },
                  [
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.offset,
                            expression: "offset",
                          },
                        ],
                        attrs: { type: "number", placeholder: "0 mm" },
                        domProps: { value: _vm.offset },
                        on: {
                          change: _vm.updateOrderObject,
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.offset = $event.target.value
                          },
                        },
                      }),
                      _vm._v("\n          mm"),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }